import { Text } from "components";

import SemiGauge from "../shared/SemiGauge";

import classes from "./ProgressSection.module.css";

interface MonthlyProgressProps {
  title: string;
  value: number;
  target: number;
  valueLabel: string;
  targetLabel: string;
  projectionLabel: string;
}

const MonthlyProgress = ({
  title,
  value,
  target,
  valueLabel,
  targetLabel,
  projectionLabel,
}: MonthlyProgressProps) => {
  return (
    <div className={classes.panel}>
      <Text className={classes.panelTitle}>{title}</Text>

      <div className={classes.monthlyBody}>
        <SemiGauge
          size="lg"
          value={value}
          target={target}
          color="#be4647"
          className={classes.monthlyGauge}
        />

        <Text className={classes.monthlyValue}>{`${valueLabel}/${targetLabel}`}</Text>
        <Text className={classes.monthlyProjection}>{projectionLabel}</Text>
      </div>
    </div>
  );
};

export default MonthlyProgress;
